export const options = ['Week', 'Month', 'YTD'];
